__turbopack_context__.v({
  "helper": "index-module__eUv39q__helper",
  "maxWidth": "index-module__eUv39q__maxWidth",
  "wrapper": "index-module__eUv39q__wrapper",
});
